import * as React from 'react';

export interface UTMAIconProps {
  className?: string;
  size?: number;
  title?: string;
}

/**
 * UTMAIcon — PCB Retail Modal entity icon (v2.5)
 *
 * @description Uniform Transfers to Minors Act account. UTMA-labeled document with graduation cap corner badge (education savings).
 */
const UTMAIcon: React.FunctionComponent<UTMAIconProps> = ({
  className,
  size = 40,
  title = 'Uniform Transfers to Minors Act',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    className={className}
    role="img"
    aria-label={title}
  >
    <title>{title}</title>
      <path d="M10 4 Q10 3 11 3 L32 3 L40 11 L40 43 Q40 44 39 44 L11 44 Q10 44 10 43 Z" fill="#FFFFFF" stroke="#185FA5" strokeWidth="1.4"/>
      <path d="M32 3 L32 11 L40 11 Z" fill="#185FA5"/>
      <text x="25" y="24" textAnchor="middle" fontFamily="Roboto, sans-serif" fontSize="9" fontWeight="900" fill="#185FA5" letterSpacing="0.4">UTMA</text>
      <line x1="14" y1="29" x2="36" y2="29" stroke="#185FA5" strokeWidth="0.8"/>
      <line x1="14" y1="32" x2="32" y2="32" stroke="#185FA5" strokeWidth="0.8"/>
      <circle cx="34" cy="38" r="4.5" fill="#185FA5"/>
      <path d="M30.5 37 L34 35.5 L37.5 37 L34 38.5 Z" fill="#FFFFFF"/>
      <path d="M32 38 L36 38 L35.5 39.5 L32.5 39.5 Z" fill="#FFFFFF"/>
      <line x1="37.5" y1="37" x2="37.8" y2="39" stroke="#FFFFFF" strokeWidth="0.5"/>
      <circle cx="37.8" cy="39.3" r="0.5" fill="#d4a958"/>
  </svg>
);

export default UTMAIcon;
